import { type EnvironmentInterface } from './environment-interface';

export const environment: EnvironmentInterface = {
  authentication: {
    authority:
      'https://login.microsoftonline.com/329e91b0-e21f-48fb-a071-456717ecc28e/v2.0',
    clientId: '5af22a4d-39b7-4cf8-ad7a-fc5464496f88',
    redirectUri: '/',
    scopes: ['api://8a939de9-edc4-4d5a-9788-9e4928bed218/Back.Read'],
  },
  backend_url: 'https://dev.api.archimed.iasp.tgscloud.net',
  stripOntologyPrefix: true,
};
